module.exports = __webpack_public_path__ + "img/poster.e1978a73.jpg";